/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";
console.log('JS loaded');

// import
import gsap from 'gsap.min';
import { ScrollTrigger } from 'ScrollTrigger.min';
import ScrollSpy from 'scrollspy';

function preventScroll(event) {
    event.preventDefault();
}

function disableScrolling() {
    // disable scrolling:
    window.addEventListener('wheel', preventScroll, { passive: false });
    window.addEventListener('touchmove', preventScroll, { passive: false });            
}

function enableScrolling() {
    // re-enable scrolling:
    window.removeEventListener('wheel', preventScroll);
    window.removeEventListener('touchmove', preventScroll);
}
    
document.addEventListener('DOMContentLoaded', function () {
    console.log('Init Scripts');

    // menu
    const navbar = document.getElementsByClassName('navbar');
    const menuBtn = document.getElementById('menu-burger');
    const b1 = document.querySelector('#menu-burger .b1');
    const b2 = document.querySelector('#menu-burger .b2');
    const overlay = document.getElementById('menu-overlay');
    const menuItems = gsap.utils.toArray('.menuItems a');

    let mm = gsap.matchMedia();
    let menuOpen = false;
    let navTl = null;
    const breakPoint = 1200;

    mm.add({
        isDesktop: `(min-width: ${breakPoint}px)`,
        isMobile: `(max-width: ${breakPoint}px)`,
    }, (context) => {
        let { isDesktop, isMobile } = context.conditions;

        // hide overlay
        gsap.set(overlay, {
            yPercent: isMobile ? -110 : 0
        })
        // set menuItems
        gsap.set(menuItems, {
            opacity: isMobile ? 0 : 1
        })

        // overlay timeline
        navTl = gsap.timeline({
            defaults: {
                ease: 'power4.inOut',
                repeatRefresh: true,
            }
        });

        navTl
            .to(b1, {
                y: '-=5',
                duration: 0.3
            })
            .to(b2, {
                y: '+=5',
                duration: 0.3
            }, "-=0.3")
            .to(b1, {
                rotation: 45,
                transformOrigin: '50% 50%',
                duration: 0.4
            })
            .to(b2, {
                rotation: -45,
                transformOrigin: '50% 50%',
                duration: 0.4
            }, "-=0.4")
            .to(overlay, {
                yPercent: 0,
                duration: 1
            }, "-=1")
            .to(menuItems, {
                opacity: 1,
                stagger: 0.1,
                duration: 0.1
            }, "-=0.1")
        navTl.pause();
    })


    // set navbar
    gsap.set(navbar, {
        backgroundColor: 'rgba(255, 255, 255, 0)'
    });

    // nav timeline background
    var navbarTl = gsap.timeline({
        defaults: {
            ease: 'easeInOut',
            repeatRefresh: true
        }
    });

    navbarTl.to(navbar, {
        ease: 'easeInOut',
        backgroundColor: 'rgba(255, 255, 255, 0.4)',
        backdropFilter: "blur(60px)",
        duration: 0.1,
        scrollTrigger: {
            trigger: '.navbar-trigger',
            start: '=+100',
            end: '=+200',
            scrub: 1
        }
    });

    // toggle menu

    menuBtn.addEventListener('click', (evt) => {
        evt.preventDefault();
        if (!menuOpen) {
            document.querySelector('body').classList.add('menu-open');
            navTl.play();
            menuOpen = true;
            // disable scrolling:
            disableScrolling();
        } else {
            document.querySelector('body').classList.remove('menu-open');
            navTl.reverse();
            menuOpen = false;
            // re-enable scrolling:
            enableScrolling();
        }
    })

    // scrollspy
    let navitems = document.querySelectorAll('.scrollspy-link');
    if (navitems.length > 1) {
        var spy = new ScrollSpy('#js-scrollspy', {
            nav: '.js-scrollspy-nav > a.scrollspy-link',
            className: 'active'
        });
        navitems.forEach(item => {
            item.addEventListener('click', (evt) => {
                if (menuOpen) {
                    enableScrolling();
                    // Delay setting the location some time
                    evt.preventDefault();
                    setTimeout(function () {
                        document.querySelector('body').classList.remove('menu-open');
                        location.href = evt.target.href;
                    }, 1500);

                    navTl.reverse();
                    menuOpen = false;
                }
            });
        });

    }

});

